import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, MessageSquare, Phone, Shield } from 'lucide-react';

function ContactSupport() {
  return (
    <div className="support-page" data-testid="contact-support-page">
      <div className="support-container">
        <Link to="/support" className="support-back-link">
          <ArrowLeft size={16} />
          Back to Support
        </Link>

        <div className="support-header">
          <div className="support-icon">
            <Mail size={28} />
          </div>
          <h1>Contact Support</h1>
          <p className="support-subtitle">
            Get help from our support team
          </p>
        </div>

        {/* Contact Methods */}
        <div className="contact-methods" data-testid="contact-methods">
          <div className="contact-card">
            <div className="contact-icon">
              <Mail size={24} />
            </div>
            <h3>Email Support</h3>
            <p>Send us an email and we'll respond within 24-48 hours.</p>
            <a href="mailto:support@tradelife.app" className="contact-link">
              support@tradelife.app
            </a>
          </div>

          <div className="contact-card disabled">
            <div className="contact-icon">
              <MessageSquare size={24} />
            </div>
            <h3>Live Chat</h3>
            <p>Live chat support is not currently available.</p>
            <span className="contact-unavailable">Coming Soon</span>
          </div>

          <div className="contact-card disabled">
            <div className="contact-icon">
              <Phone size={24} />
            </div>
            <h3>Phone Support</h3>
            <p>Phone support is not currently available.</p>
            <span className="contact-unavailable">Coming Soon</span>
          </div>
        </div>

        {/* Support Hours */}
        <div className="support-card">
          <h3>Support Hours</h3>
          <p className="support-hours">
            Monday - Friday: 9:00 AM - 5:00 PM (GMT)
          </p>
          <p className="support-note">
            We aim to respond to all enquiries within 24-48 business hours.
          </p>
        </div>

        {/* Before Contacting */}
        <div className="support-card">
          <h3>Before Contacting Support</h3>
          <ul className="before-contact-list">
            <li>Check the <Link to="/support/help">Help Centre</Link> for answers to common questions</li>
            <li>Review the <Link to="/support/status">System Status</Link> for any known issues</li>
            <li>Ensure you have your organisation details ready</li>
          </ul>
        </div>

        {/* Trust Notice */}
        <div className="support-trust-notice" data-testid="trust-notice">
          <Shield size={18} />
          <p>
            TradeLife support can only access technical system status — never your financial data or documents. 
            Any access is logged and visible to you.
          </p>
        </div>
      </div>
    </div>
  );
}

export default ContactSupport;
